export default {
    name: 'ReachedInspectionLimitMessage',

    functional: true,

    render(h, { parent }) {
        return h('div', {
            class: 'item',
        }, [
            h('h4', parent.$t('You reached your monthly inspection limit')),
            h('p', parent.$t('Upgrade on desktop and conduct as many inspections as you want')),
        ]);
    },
};
